<template>
  <v-container class="mt-12 pt-8" style="background: #fafafa;">
    <v-row style="background: #fafafa;">
      <v-col cols="12" class="mx-auto" PANNELS>
        <v-card :loading="loading">
          <v-card-title :class="`${arabic ? 'arFont' : 'enFont'} flex justify-space-between`">
            <div>
              {{ i18n["past_documents"] }}
            </div>

            <v-btn @click.prevent="dialog = true" dark color="blue darken-4">{{ i18n.upload }}</v-btn>
          </v-card-title>
          <Paging
            :resourceSettings="resourceSettings"
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
          <v-card-text>
            <ListPastDocuments :types="types" :documents="resource.data" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <UploadCandidateDocumentDialog
      :types="types"
      @submitUploadedFile="submitUploadedFile"
      :dialog="dialog"
      @closeDialog="dialog = false"
    />
  </v-container>
</template>

<script>
import Paging from "@/components/Paging";
import ListPastDocuments from "@/components/listPastDocuments.vue";
import UploadCandidateDocumentDialog from "@/components/uploadCandidateDocumentDialog.vue";

export default {
  components: {
    Paging,
    ListPastDocuments,
    UploadCandidateDocumentDialog,
  },
  data() {
    return {
      types: [
        { slug: "other", ar: "مستندات اخرى" },
        { slug: "cv", ar: "سيرة ذاتية" },
        { slug: "portrait", ar: "صورة شخصية" },
        { slug: "certificate", ar: "شهادة" },
        { slug: "school_certificate", ar: "شهادة مدرسية" },
        { slug: "uni_certificate", ar: "شهادة جامعية" },
        { slug: "b_1_certificate", ar: "شهادة مستوى B1" },
        { slug: "b_2_certificate", ar: "شهادة مستوى B2" },
        { slug: "visa", ar: "نسخة عن التأشيرة" },
      ],
      dialog: false,
      loading: false,
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      resource: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    async submitUploadedFile(url, slug) {
      return new Promise(async (res, rej) => {
        await this.$store.dispatch("postResource", {
          resource: "/documents",
          value: {
            type: slug,
            url: url,
          },
        });

        this.dialog = false;

        this.loadResource();
      });
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch("getResource", { resource: "/documents", page: `?page=${n}` });
        } else {
          this.resource = await this.$store.dispatch("searchResource", {
            resource: "/documents" + `/search?page=${n}`,
            value: this.search,
          });
        }
        this.loading = false;
      });
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.resource = await this.$store.dispatch("getResource", { resource: "/documents" });
        res();
      });
    },
    async init() {
      this.loading = true;
      await this.loadResource();
      this.loading = false;
    },
  },
  async created() {
    await this.init();
  },
};
</script>
